import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  AppBar, Toolbar, Typography, Button, Box, IconButton, Menu, MenuItem,
  useTheme, useMediaQuery,
} from '@mui/material';
import { Menu as MenuIcon, Storefront as StorefrontIcon } from '@mui/icons-material';

const GRADIENT = 'linear-gradient(45deg, #1a237e 30%, #3949ab 90%)';

const PublicHeader = ({ onOpenConsult }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState(null);

  const goHome = () => navigate('/');
  const goPreview = () => navigate('/preview');

  const navButtons = [
    { label: 'صفحه اصلی', action: goHome },
    { label: 'نمای برنامه', action: goPreview },
    { label: 'ثبت‌نام و مشاوره', action: onOpenConsult, highlight: true },
  ];

  const handleMenuClick = (action) => {
    setAnchorEl(null);
    if (action) action();
  };

  return (
    <AppBar position="sticky" elevation={3} sx={{ background: GRADIENT }}>
      <Toolbar sx={{ justifyContent: 'space-between' }}>
        {/* برند */}
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, cursor: 'pointer' }} onClick={goHome}>
          <StorefrontIcon sx={{ color: '#ffd54f' }} />
          <Typography variant="h6" sx={{ fontWeight: 'bold', color: 'white' }}>
            مدیریت گالری پرده
          </Typography>
        </Box>

        {/* دسکتاپ */}
        {!isMobile && (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            {navButtons.map((b) => (
              <Button
                key={b.label}
                onClick={b.action}
                variant={b.highlight ? 'contained' : 'text'}
                sx={b.highlight
                  ? { bgcolor: '#ffd54f', color: '#1a237e', fontWeight: 'bold', '&:hover': { bgcolor: '#ffca28' } }
                  : { color: 'white' }}
              >
                {b.label}
              </Button>
            ))}
            <Button onClick={() => navigate('/login')} variant="outlined"
              sx={{ color: 'white', borderColor: 'rgba(255,255,255,0.6)', '&:hover': { borderColor: 'white' } }}>
              ورود
            </Button>
          </Box>
        )}

        {/* موبایل */}
        {isMobile && (
          <>
            <IconButton onClick={(e) => setAnchorEl(e.currentTarget)} sx={{ color: 'white' }}>
              <MenuIcon />
            </IconButton>
            <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={() => setAnchorEl(null)}>
              {navButtons.map((b) => (
                <MenuItem key={b.label} onClick={() => handleMenuClick(b.action)}
                  sx={b.highlight ? { fontWeight: 'bold', color: '#1a237e' } : {}}>
                  {b.label}
                </MenuItem>
              ))}
              <MenuItem onClick={() => handleMenuClick(() => navigate('/login'))}>ورود به سیستم</MenuItem>
            </Menu>
          </>
        )}
      </Toolbar>
    </AppBar>
  );
};

export default PublicHeader;
